var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 49,
    viewBox: "0 0 31 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3198 0C10.5867 0 6.73584 3.85084 6.73584 8.58397V25.4546C6.73584 30.1871 10.5867 34.038 15.3198 34.038C20.0529 34.038 23.9038 30.2139 23.9038 25.5135V8.58397C23.9038 3.85084 20.0529 0 15.3198 0ZM20.3266 25.513C20.3266 28.2409 18.0804 30.4607 15.3198 30.4607C12.5592 30.4607 10.3125 28.2152 10.3125 25.454V8.58397C10.3125 5.82282 12.5587 3.57665 15.3198 3.57665C18.081 3.57665 20.3271 5.82282 20.3266 8.58397V25.513Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1084 39.165H13.5317V47.2126H17.1084V39.165Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0292 45.4229H10.6106C9.62283 45.4229 8.82227 46.2234 8.82227 47.2112C8.82227 48.1989 9.62283 48.9995 10.6106 48.9995H20.0292C21.017 48.9995 21.8175 48.1989 21.8175 47.2112C21.8175 46.2234 21.017 45.4229 20.0292 45.4229Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8519 22.4736C27.8641 22.4736 27.0635 23.2742 27.0635 24.262V25.6926C27.0635 32.1676 21.7951 37.4361 15.3201 37.4361C8.84458 37.4361 3.57665 32.1677 3.57665 25.6926V24.262C3.57665 23.2742 2.77608 22.4736 1.78832 22.4736C0.800564 22.4736 0 23.2742 0 24.262V25.6926C0 34.1401 6.8726 41.0127 15.3201 41.0127C23.7676 41.0127 30.6402 34.1401 30.6402 25.6926V24.262C30.6402 23.2743 29.8396 22.4736 28.8519 22.4736Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDarkIcon);
export default __webpack_public_path__ + "static/media/audioDarkIcon.6c0c7c2d2c61c14a7fbd2daed8764dde.svg";
export { ForwardRef as ReactComponent };